
import { IQuestionaireRepository } from "@/domain/repositories/IQuestionaireRepository";
import { IUpdateQuestionaireStatusUseCase } from "@/domain/usecases/IUpdateQuestionaireStatusUseCase";

export class UpdateQuestionaireStatusUseCase implements IUpdateQuestionaireStatusUseCase {
    repository: IQuestionaireRepository
    constructor(repository: IQuestionaireRepository) {
        this.repository = repository
    }
    execute(questionaireId: string, active: boolean): Promise<void> {
        return this.repository.update(questionaireId, { active })
    }

}